export default function initNavbar() {
  const navbar = document.querySelector(".main-navbar");
  const navToggle = document.getElementById("navToggle");
  const navMenu = document.getElementById("navMenu");
  const navLinks = document.querySelectorAll(".nav-link-item, .nav-resume-btn");

  if (!navbar) return;

  // Toggle mobile navigation
  if (navToggle && navMenu) {
    navToggle.addEventListener("click", () => {
      navToggle.classList.toggle("is-active");
      navMenu.classList.toggle("is-active");
    });

    // Close menu when clicking nav link
    navLinks.forEach((link) => {
      link.addEventListener("click", () => {
        navToggle.classList.remove("is-active");
        navMenu.classList.remove("is-active");
      });
    });

    // Close menu on click outside
    document.addEventListener("click", (e) => {
      if (!navbar.contains(e.target) && navMenu.classList.contains("is-active")) {
        navToggle.classList.remove("is-active");
        navMenu.classList.remove("is-active");
      }
    });
  }

  // Scroll effect (elevate navbar on scroll)
  const handleScroll = () => {
    if (window.scrollY > 20) {
      navbar.classList.add("main-navbar--scrolled");
    } else {
      navbar.classList.remove("main-navbar--scrolled");
    }
  };

  window.addEventListener("scroll", handleScroll);
  handleScroll();
}
